// extracted by mini-css-extract-plugin
export var productImage = "_yg-0";